import { MetricCard } from 'components/ui/MetricCard/MetricCard'
import { NavBar } from 'components/NavBar/NavBar'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { clearSingleReport, getSingleReport } from 'features/reports/reportsSlice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Animation, Flex, H1, H1WithBack, H2, PageWrapper, Separator } from 'styling/GlobalStyles'
import { tokens } from 'styling/tokens'
import { BodyText } from 'styling/Typography'
import { formatDateForDisplay } from 'utils/helpers'

export const SingleReport = () => {

    const { id } = useParams()
    const dispatch = useDispatch<AppDispatch>()
    const { singleReport } = useSelector((state: RootState) => state.reports)

    useEffect(() => {
        dispatch(getSingleReport(Number(id)))
        return () => {
            dispatch(clearSingleReport())
        }
    }, [])
    return <>
        <NavBar />
        <Animation>
            <PageWrapper noFooter >
                <H1WithBack arrow title={'Report ' + id} />
                <Separator />
                {singleReport && <><Flex width={screen.availWidth < 500 ? '100%' : '50%'} column gap='1rem' padding='0 .5rem' >
                    <Flex between> <H2>Date:</H2><BodyText><span></span>{formatDateForDisplay(singleReport.date)}</BodyText></Flex>
                    <Flex gap='1rem' wrap>
                        <MetricCard label='Total Fuel Cost' value={'GH₵ ' + singleReport.fuelCostTotal} accentColor={tokens.accent.base} />
                        <MetricCard label='Estimated Total Cost' value={'GH₵ ' + singleReport.estimatedCostTotal} accentColor={tokens.accent.base} />
                        <MetricCard label='Actual Total Cost' value={'GH₵ ' + singleReport.actualCostTotal} accentColor={tokens.accent.base} />
                        <MetricCard label='Completed Tasks' value={String(singleReport.completedTaskCount)} accentColor={tokens.accent.base} />
                    </Flex>
                </Flex>
                    <Flex width={screen.availWidth < 500 ? '100%' : '50%'} column gap='1rem' mt='40'>
                        <H1>Shifts:</H1>
                        {singleReport.shiftData.map(s => <Flex style={{ borderBottom: `1px solid ${tokens.border.hairline}` }} key={s.shiftId} column gap='.2rem' >
                            <Flex between padding={screen.availWidth < 500 ? '0 .5rem' : '0 2rem'}>
                                <H2>Shift Name</H2><BodyText>{s.shiftName}</BodyText>
                            </Flex>
                            <Flex between padding={screen.availWidth < 500 ? '0 .5rem' : '0 2rem'}>
                                <H2>User Count</H2><BodyText>{s.userCount}</BodyText>
                            </Flex>
                        </Flex>)}
                    </Flex>
                    <Flex width={screen.availWidth < 500 ? '100%' : '50%'} column gap='1rem' mt='40'>
                        <H1>Reported Issues:</H1>
                        {singleReport.reportedIssues.length > 0 ? singleReport.reportedIssues.map(i => <Flex key={i.id} column style={{ borderBottom: `1px solid ${tokens.border.hairline}` }} gap='.2rem' >
                            <Flex between padding={screen.availWidth < 500 ? '0 .5rem' : '0 2rem'}>
                                <H2>Type</H2><BodyText>{i.type}</BodyText>
                            </Flex>
                            <Flex between padding={screen.availWidth < 500 ? '0 .5rem' : '0 2rem'}>
                                <H2>Description</H2><BodyText>{i.description}</BodyText>
                            </Flex>
                            <Flex between padding={screen.availWidth < 500 ? '0 .5rem' : '0 2rem'}>
                                <H2>Task Name</H2><BodyText>{i.taskName}</BodyText>
                            </Flex>
                            <Flex between padding={screen.availWidth < 500 ? '0 .5rem' : '0 2rem'}>
                                <H2>Solution Task Name</H2><BodyText>{i.solutionTaskName}</BodyText>
                            </Flex>
                            <Flex between padding={screen.availWidth < 500 ? '0 .5rem' : '0 2rem'}>
                                <H2>Is Resolved</H2><StatusPill status={i.isResolved ? 'success' : 'neutral'}>{i.isResolved ? 'Resolved' : 'Unresolved'}</StatusPill>
                            </Flex>
                        </Flex>) : <BodyText>No Issues Reported</BodyText>}
                    </Flex>
                </>}
            </PageWrapper>
        </Animation>
    </>
}


export interface ISingleReport {
    id: number;
    date: string;
    fuelCostTotal: number;
    estimatedCostTotal: number;
    actualCostTotal: number;
    completedTaskCount: number;
    shiftData: {
        shiftId: number;
        shiftName: string;
        userCount: number;
    }[];
    reportedIssues: {
        id: number;
        type: string;
        description: string;
        taskName: string;
        solutionTaskName: string;
        isResolved: boolean;
    }[];
}